import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRiSuitcaseLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 23,
	height: 23,
	viewBox: "0 0 23 23",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.3763 2.875C14.6305 2.875 14.8742 2.97597 15.0539 3.15569C15.2337 3.33541 15.3346 3.57917 15.3346 3.83333V5.75H20.1263C20.3805 5.75 20.6242 5.85097 20.8039 6.03069C20.9837 6.21041 21.0846 6.45417 21.0846 6.70833V19.1667C21.0846 19.4208 20.9837 19.6646 20.8039 19.8443C20.6242 20.024 20.3805 20.125 20.1263 20.125H2.8763C2.62214 20.125 2.37838 20.024 2.19866 19.8443C2.01894 19.6646 1.91797 19.4208 1.91797 19.1667V6.70833C1.91797 6.45417 2.01894 6.21041 2.19866 6.03069C2.37838 5.85097 2.62214 5.75 2.8763 5.75H7.66797V3.83333C7.66797 3.57917 7.76894 3.33541 7.94866 3.15569C8.12838 2.97597 8.37214 2.875 8.6263 2.875H14.3763ZM15.3346 7.66667H7.66797V18.2083H15.3346V7.66667ZM3.83464 7.66667V18.2083H5.7513V7.66667H3.83464ZM13.418 4.79167H9.58464V5.75H13.418V4.79167ZM17.2513 7.66667V18.2083H19.168V7.66667H17.2513Z",
		fill: "#79C912"
	})
});
export default SvgRiSuitcaseLine;
